import axios from "axios";
import { toast } from "sonner";

let last402 = { msg: null, t: 0 };
const toastError = toast.error;
toast.error = (m, o) => (o?.id !== "plan-402" && m === last402.msg && Date.now() - last402.t < 3000 ? undefined : toastError(m, o));

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    if (err.response?.status === 402 && !(err.response.data instanceof Blob)) {
      last402 = { msg: errMsg(err), t: Date.now() };
      toast.error(last402.msg, { id: "plan-402", action: { label: "View plans", onClick: () => window.location.assign("/billing") } });
      err.handled402 = true;
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function download(path, filename) {
  let r;
  try { r = await api.get(path, { responseType: "blob" }); }
  catch (e) {
    let msg = e.message;
    try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch (x) { /* non-JSON body */ }
    if (e.response?.status === 402) {
      toast.error(msg, { id: "plan-402", action: { label: "View plans", onClick: () => window.location.assign("/billing") } });
    } else {
      toast.error(msg);
    }
    return;
  }
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export async function blobUrl(path) {
  const r = await api.get(path, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}

export async function streamAI(body, onText) {
  let job;
  try { job = (await api.post("/ai/run", body)).data.job_id; } catch (e) { throw new Error(errMsg(e)); }
  const start = Date.now();
  let shown = "";
  while (Date.now() - start < 10 * 60 * 1000) {
    await new Promise((r) => setTimeout(r, 1000));
    let j;
    try { j = (await api.get(`/ai/jobs/${job}`)).data; } catch (e) { continue; }
    if (j.text && j.text !== shown) { shown = j.text; onText(shown); }
    if (j.status === "done") return { text: j.text, ...(j.result || {}) };
    if (j.status === "failed") throw new Error(j.error || "AI request failed");
  }
  throw new Error("AI request timed out. Please retry");
}

export async function streamAILegacy(body, onText, retried = false) {
  const res = await fetch(`${API}/ai/run`, {
    method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
  });
  if (res.status === 401 && !retried) {
    await api.post("/auth/refresh");
    return streamAI(body, onText, true);
  }
  if (!res.ok) {
    let msg = "AI request failed";
    try { const j = await res.json(); msg = typeof j.detail === "string" ? j.detail : msg; } catch (e) { /* ignore */ }
    throw new Error(msg);
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "", full = "", final = null;
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const j = JSON.parse(p.slice(6));
      if (j.t) { full += j.t; onText(full); }
      if (j.error) throw new Error(j.error);
      if (j.done) final = j;
    }
  }
  return { text: full, ...(final || {}) };
}
